import Breadcrumb from "atoms/breadcrumbs/breadcrumb";
import React from "react";

// -------------------------------------------------------------------------------------------------
// #region Component
// -------------------------------------------------------------------------------------------------

const AnnouncementsAdminBreadcrumb: React.FC = () => (
    <Breadcrumb>
        <span className="c-breadcrumb__label">Announcements</span>
    </Breadcrumb>
);

// #endregion Component

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export default AnnouncementsAdminBreadcrumb;

// #endregion Exports
